<template>
  <div class="patient-landing">
    <video-modal :open="videoModalOpen" @close="closeModal"></video-modal>

    <section class="section intro">
      <div class="container">
        <div class="row">
          <div class="col-md-4 white text-center text-sm-left">
            <h1 class="m-t-0">Tired of filling out the same frustrating forms over and over again?</h1>
            <div class="m-y">
              <a @click="openModal" id="openVideoModal"><img src="~assets/images/brochure/patient/play-icon.png"></a>
            </div>
            <p class="lead">LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.</p>
            <div class="m-b-lg">
              <app-links :appLinks="links"/>
            </div>
          </div>
          <div class="col-md-4 col-md-offset-4">
            <div class="card">
              <div class="card-content text-center">
                <h2 class="m-t-0">Patients</h2>
                <div class="m-b"><router-link to="/signup" class="btn btn-primary">Sign up for free</router-link></div>
              </div>
            </div>
            <div class="card">
              <div class="card-content text-center">
                <h2 class="m-t-0">Healthcare Professionals</h2>
                <div class="m-b">
                  <a @click="navAndSetContext('practice')">Practice</a>
                  <span>&nbsp;|&nbsp;</span>
                  <a @click="navAndSetContext('academic')">Academic</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/patient/2.png">
            <h2>No More<br>Paper Forms</h2>
            <p>Complete electronically before you arrive</p>
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/patient/3.png">
            <h2>Capture Your<br>Details Once</h2>
            <p>And you’ll never need to do it again</p>
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/patient/4.png">
            <h2>Your Information Is<br>Secure</h2>
            <p>You choose who has access to your information</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-primary" v-once>
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-center">
            <img src="~assets/images/brochure/patient/share-with-practice.png" class="img-responsive center-block">
          </div>
          <div class="col-md-6">

            <h2 class="">Patient Benefits</h2>
            <p class="lead m-b-lg">Frustrated with filling out the same medical forms over and over again? Simplify your medical life with LogBox.</p>
            <ul class="feature-list fa-ul">
              <li class="hidden"><i class="fa-li fa fa-check"></i>Stop filling out the same medical forms over and over again. </li>
              <li><i class="fa-li fa fa-check"></i>Free for patients. </li>
              <li><i class="fa-li fa fa-check"></i>Keep your information secure on a mobile app or website. </li>
              <li><i class="fa-li fa fa-check"></i>Share your information with any healthcare professional you choose.</li>
              <li><i class="fa-li fa fa-check"></i>LogBox works regardless of your medical aid. </li>
              <li><i class="fa-li fa fa-check"></i>Stay in control of your information, you decide who sees it and when.</li>
              <li><i class="fa-li fa fa-check"></i>Your information is secured according to the highest international standards.</li>
            </ul>

          </div>
        </div>
      </div>
    </section>

    <section class="" v-once>
      <div class="container-fluid">
        <div class="row flush">
          <div class="col-md-4 grey-1">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Patient</h3>
              <p>LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.</p>
              <router-link to="/signup" class="btn btn-primary">Sign Up Now</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-2">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Practice</h3>
              <p>Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.</p>
              <router-link to="/practice" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-3">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Academic</h3>
              <p>A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.</p>
              <router-link to="/academic" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import VideoModal from 'components/common/modals/VideoModal';
  import PartnerBranding from 'components/common/PartnerBranding';
  import AppLinks from 'components/common/AppLinks';

  export default {
    name: 'patient',
    components: {
      VideoModal,
      PartnerBranding,
      AppLinks,
    },
    data: () => ({
      videoModalOpen: false,
      links: {
        andriod: `${process.env.VUE_APP_PATIENT_APP_ANDROID}`,
        apple: `${process.env.VUE_APP_PATIENT_APP_ISO}`,
      },
    }),
    methods: {
      openModal() {
        this.videoModalOpen = true;
      },
      closeModal() {
        this.videoModalOpen = false;
      },
      navAndSetContext(context) {
        this.$store.dispatch('updateContext', { context });
        this.$router.push(`/${context}`);
      },
    },
    mounted() {
      this.$store.dispatch('updateContext', {
        context: 'patient',
      });
    },
  };

</script>



// WEBPACK FOOTER //
// Patient.vue?0c29d4c3